/**
 * Table Wisdom & Query Intent API (wisdom_feature_spec.md).
 * Reads need auth; writes are admin-only (backend-enforced).
 */
import { API_BASE, fetchApi, getAuthHeaders } from './apiClient';

export interface TableWisdom {
  dbname: string;
  table_name: string;
  purpose: string | null;
  how_to_fetch: string | null;
  sample_rows: Record<string, unknown>[] | null;
  columns_snapshot: string[] | null;
  updated_by?: string | null;
}

export interface IntentWisdom {
  intent: string;
  must_have: string | null;
  typical_rows: string | null;
  example_sql: string | null;
  notes: string | null;
  updated_by?: string | null;
}

async function request<T>(path: string, init: RequestInit): Promise<T> {
  const headers = await getAuthHeaders();
  const response = await fetchApi(`${API_BASE}${path}`, { ...init, headers });
  if (!response.ok) {
    const data = await response.json().catch(() => null);
    throw new Error(data?.detail || `Wisdom API failed (${response.status})`);
  }
  return response.json();
}

export const wisdomApi = {
  getForTables(fqns: string[]): Promise<TableWisdom[]> {
    return request(`/wisdom/tables?fqns=${encodeURIComponent(fqns.join(','))}`, { method: 'GET' });
  },
  saveTable(w: TableWisdom): Promise<{ status: string }> {
    return request('/wisdom/table', { method: 'POST', body: JSON.stringify(w) });
  },
  listIntents(): Promise<IntentWisdom[]> {
    return request('/wisdom/intents', { method: 'GET' });
  },
  saveIntent(w: IntentWisdom): Promise<{ status: string }> {
    return request('/wisdom/intent', { method: 'POST', body: JSON.stringify(w) });
  },
};
